<template>
  <div id='' style='' class='gPageBorder' v-loading='loading'>
    <div v-show="info?info.status == 3:false">
      <el-alert
        style='display:flex;display:-webkit-flex;margin: 0 0 5px 0;'
        :title="reason"
        type="error"
        show-icon>
      </el-alert>
    </div>
    <el-form class='gForm' label-position="right" ref="firm" :rules='rules' label-width="12.5%" :model='firm'>
      <el-form-item :label="$t('app_srcname')" prop='name'>
        <el-input v-model="firm.name" placeholder=""></el-input>
      </el-form-item>
      <el-form-item :label="$t('app_srcdesc')" prop='desc'>
        <el-input v-model="firm.desc" placeholder=''></el-input>
      </el-form-item>
      <el-form-item :label="$t('app_distributor')" prop='mech'>
        <MechanismSelector style='' :data="mechanismData"></MechanismSelector>
      </el-form-item>
      <el-form-item :label="$t('app_ulfile')" prop='url'>
        <el-upload
          class="upload-demo"
          name='fileUpload'
          :action="fileUploadUrl"
          :before-upload="srcBefore"
          :on-success="srcSuccess"
          :file-list="srcList">
          <el-button size="" type="primary">{{$t('app_clickUpdate')}}</el-button>
          <!-- <div slot="tip" style='' class="el-upload__tip">{{$t('app_asfState')}}&nbsp;</div> -->
        </el-upload>
      </el-form-item>
      <el-form-item :label="$t('app_version')" prop='ver'>
        <el-input v-model="firm.ver" placeholder=''></el-input>
      </el-form-item>
      <el-form-item>
        <el-button  type='' style='' @click="cancel">{{$t('app_cancel')}}</el-button>
        <el-button  type='primary' style='' @click="save('firm')">{{$t('app_save')}}</el-button>
      </el-form-item>
    </el-form>
   
  </div>
</template>

<style>
</style>

<script> 
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default{
    data () {
      var _this = this
      var phoneCheck = (rule, value, callback) => {
        if (!this.isLegalMobile(value)) {
          callback(new Error(this.$t('app_phoneIllegal')));
        } else {
          callback()
        }
      }
      return {
        fatherList: [],
        info: '',
        srcList: [],
        mechanismData: {
          placeholder: _this.$t('lin_global.place_areaid'),
          callback (value) {
            _this.firm.mech = value
          }
        },
        firm: {
          name: '',
          desc: '',
          mech: '',
          cid: '',
          ver: '',
          md5: '',
          type: '2',
          size: '',
          url: ''
        },
        firms: [],
        loading: false,
        dvs: [],
        mds: [],
        rules: {
          name: [
            { required: true, message: this.$t('mao_global.tip.pleaseInput'), trigger: 'blur' }
          ],
          url: [
            { required: true, message: this.$t('mao_global.tip.pleaseInput'), trigger: 'blur' }
          ],
          desc: [
            { required: true, message: this.$t('mao_global.tip.pleaseInput'), trigger: 'blur' }
          ],
          mech: [
            { required: true, message: this.$t('app_select'), trigger: 'blur'/*, validator: phoneCheck*/}
          ],
          type: [
            { required: true, message: this.$t('app_select'), trigger: 'blur' }
          ],
          firm: [
            { required: true, message: this.$t('app_select'), trigger: 'blur' }
          ],
          model: [
            { required: true, message: this.$t('app_select'), trigger: 'blur' }
          ],
          ver: [
            { required: true, message: this.$t('mao_global.tip.pleaseInput'), trigger: 'blur' }
          ],
          remark: [
            { required: true, message: this.$t('mao_global.tip.pleaseInput'), trigger: 'blur' }
          ]
        }
      }
    },
    components: {
       MechanismSelector
    },
    computed: {
      reason () {
        if (!this.info) {
          return ''
        }
       
        var rs = this.info.refuseReason
        return rs? this.$t('app_banReason') + ':' + rs : this.$t('app_banReason')  + ':' +  this.$t('app_noInput')
      },
      fileUploadUrl () {
        // return this.$fileUpImgloadUrl
         return this.$urls.fileUrl
      }
    },
    methods: {
      srcBefore (file) {
        // console.log(file)
        var name = file.name
        if (name) { //  === 'part0.zip'
          window[this.$route.path] = 1
          return true
        } else {
          this.$message(this.$t('app_fileNameOnly') + 'part0.zip')
          return false
        } 
      },
      srcSuccess (res, file) {
        window[this.$route.path] = ''
        console.log(res)
        if (res.status === 200) {
          this.firm.md5 = res.md5
          this.srcList = [{name: file.name}]
          this.firm.url = res.fileUrl
          this.firm.size = res.appSize
          this.hBlur('fm')
        } else {
          this.srcList = []
        }
      },
      isLegalMobile (tel) {
        var sMobile = tel
        var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$"
        var re = new RegExp(regex, 'g') 
        if(!(re.test(sMobile))){
          return false
        } else {
          return true
        }
      },
      newfirm () {
        this.loading = 1
        this.$addNonAs(this.firm.name, this.firm.ver, this.firm.md5, this.firm.size, this.firm.url, this.firm.cid, this.firm.mech, this.firm.desc, this.firm.type,(res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      editfirm () {
        var data = this.info
        // console.log(this.firm)
        this.loading = 1
        this.$editNonAs(data.id, data.status, this.firm.name, this.firm.ver, this.firm.md5, this.firm.size, this.firm.url, '', this.firm.mech, this.firm.desc, this.firm.type,(res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
        }) 
      },
      save (name) {
        // console.log(this.firm)
        this.$refs[name].validate((valid) => {
          if (valid) {
            if (!this.info) {
              this.newfirm()
            } else {
              this.editfirm()
            }
          } else {
            return false
          }
        })
      },
      cancel () {
        this.$router.go(-1)
      },
      fillData (data) {
        console.log(data)
        this.firm.name = data.name
        this.firm.desc = data.memo
        this.firm.mech = data.mechanismId
        this.firm.ver = data.version
        this.firm.firm = data.manufId
        this.firm.addr = data.address
        this.firm.remark = data.memo
        this.firm.md5 = data.hashCode
        this.firm.size = data.size
        this.firm.url = data.url
        var ar = []
        if (data.url) {
          ar = data.url.split('/')
          this.srcList = [{name: ar[ar.length - 1]}]
        }
        
        var _this = this
        this.mechanismData = {
          value: data.mechanismId,
          placeholder: this.$t('lin_global.place_areaid'),
          optValue: true,
          callback (value) {
            _this.firm.mech = value.id
          }
        }

      }
    },
    mounted () {


      var data = this.$route.query.data
      this.info = data
      if (data) {
        this.fillData(data)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// edit.vue?39eb909c